document.addEventListener("DOMContentLoaded", function () {
  const video = document.querySelector("video[data-lazy-src]");
  if (video) {
    video.src = video.dataset.lazySrc;
    video.load();
    video.playbackRate = 0.5;
  }
});
